import { navigate, PATHS } from '@client/routes';
import { customerIOReset } from '@client/new/services/customerio';
import * as enums from '@playbook-technologies/common-enums';
import { PermissionScope } from '@playbook-technologies/common-enums';
import { isEmpty } from 'lodash';

export const isProduction = () => import.meta.env.VITE_ENV === 'production';
export const isIntegration = () => import.meta.env.VITE_ENV === 'integration';
export const isDevelopment = () => import.meta.env.VITE_ENV === 'development';

export interface User {
  username: string;
  role: number;
  firstName: string;
  lastName: string;
  email: string;
  token: string;
  tokenExpiresAt: string;
  influencerId?: any;
  influencer?: { firstName: string; lastName: string; id: number };
  id: number;
}

const auth = {
  getToken() {
    //console.log('[Auth] getToken() called.');
    if (localStorage && localStorage.user) {
      const user = JSON.parse(localStorage.user);
      return user.token;
    } else {
      return null;
    }
  },

  getUser(): User {
    if (localStorage && localStorage.user) {
      return JSON.parse(localStorage.user);
    } else {
      return null;
    }
  },

  logout() {
    delete localStorage.user;
    customerIOReset();
    navigate(PATHS.LOGIN);
  },
  isAdministrator() {
    if (
      localStorage.user &&
      this.getUser().role === enums.PortalUser.Role.Administrator.value
    )
      return true;
    return false;
  },

  isContentEditor() {
    if (
      localStorage.user &&
      this.getUser().role === enums.PortalUser.Role.ContentEditor.value
    )
      return true;
    return false;
  },

  isModerator() {
    if (
      localStorage.user &&
      this.getUser().role === enums.PortalUser.Role.Moderator.value
    )
      return true;
    return false;
  },

  isInfluencer() {
    if (
      localStorage.user &&
      this.getUser().role === enums.PortalUser.Role.Influencer.value
    )
      return true;
    return false;
  },

  isProduction,
  hasStripePermission() {
    const user = this.getUser();
    if (!user?.permissions || isEmpty(user?.permissions)) return false;

    return user.permissions.includes(PermissionScope.Stripe);
  },
  hasPayoutsPermission() {
    const user = this.getUser();
    if (!user?.permissions || isEmpty(user?.permissions)) return false;

    return user.permissions.includes(PermissionScope.Payouts);
  },
  getCustomPermissions() {
    const user = this.getUser();
    if (!user?.permissions || isEmpty(user?.permissions)) return [];

    return user.permissions;
  },
};

export default auth;
